// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Loader {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  display: inline-block;
  position: relative;
  background: linear-gradient(0deg, rgba(229, 9, 20, 0.2) 33%, #e50914 100%);
  animation: rotation 1s linear infinite;
}
.Loader:after {
  content: "";
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: #333;
}

@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Loader/loader.scss"],"names":[],"mappings":"AAIA;EACE,WAHK;EAIL,YAJK;EAKL,kBAAA;EACA,qBAAA;EACA,kBAAA;EACA,0EAAA;EACA,sCAAA;AAHF;AAKE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBArBG;AAkBP;;AAOA;EACE;IAAK,uBAAA;EAHL;EAIA;IAAO,yBAAA;EADP;AACF","sourcesContent":["@import '../../scss/variables';\n$base: #333;\n$size: 26px;\n\n.Loader{\n  width : $size;\n  height: $size;\n  border-radius: 50%;\n  display: inline-block;\n  position: relative;\n  background: linear-gradient(0deg, rgba($red, 0.2) 33%, rgba($red, 1) 100%);\n  animation: rotation 1s linear infinite;\n\n  &:after {\n    content: '';\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50% , -50%);\n    width : $size - 4px;\n    height: $size - 4px;\n    border-radius: 50%;\n    background: $base\n  }\n}\n\n@keyframes rotation {\n  0% { transform: rotate(0deg) }\n  100% { transform: rotate(360deg) }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
